<div class="p-2" *wfeHasRole="[Role.Host_Admin]">
    <span class="text-semi mr-2">Tenant: </span>
    <app-select
        variant="tertiary"
        placeholder="Select Tenant"
        class="tenant-select"
        [dataQa]="dataQa.tenantSelection"
        [value]="currentTenant"
        [options]="tenantOptions"
        (selectionChange)="onTenantSelect($event)" />
</div>
